import { CalendarSurfaceTransformProps } from '../interfaces/CalendarSurfaceTransformProps';
import { ColumnProvider } from '../interfaces/ColumnProvider';
import ColumnPastDayHighlightBehavior from '../logic/behaviors/column/ColumnPastDayHighlightBehavior';
import { getColumnRangeHorizontalLayout } from '../logic/getColumnRangeHorizontalLayout';
import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import { GridLines } from '../surfaceItems/GridLines';
import { createDateColumnHeader } from '../Templates';
import convertLayoutPositionToFlexStyles from '../utils/convertLayoutPositionToFlexStyles';
import { attachBehaviors } from 'owa-calendar-surface-core';
import { OwaDate } from 'owa-datetime';
import * as React from 'react';

/**
 * Creates surface grid lines
 * @param store The surface store
 * @param config The config
 */
export function createGridLines(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps
) {
    const itemsLayout = config.itemsLayout;
    const increment = store.userOptions.hourIncrement;

    return <GridLines store={store} itemsLayout={itemsLayout} increment={increment} />;
}

/**
 * Creates surface date headers
 * @param store The surface store
 * @param config The config
 */
export function createHeaders(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps,
    hideHeaderAddOns: boolean = false,
    calendarFolderId?: string
) {
    return createDatesColumnHeaders(
        config.columnProvider.columnModels,
        config.columnProvider,
        hideHeaderAddOns ? null : config.renderDateHeaderAddOn,
        config.onSurfaceClick,
        calendarFolderId
    );
}

function createDatesColumnHeaders(
    dates: OwaDate[],
    columnProvider: ColumnProvider,
    renderDateHeaderAddOn?: (date: OwaDate) => JSX.Element,
    onSurfaceClick?: (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        props?: any,
        selectedCalendarId?: string
    ) => void,
    calendarFolderId?: string
) {
    return dates.map((date, key) => {
        const columnIndex = columnProvider.getColumnIndex(date);
        let layout = getColumnRangeHorizontalLayout(columnIndex, columnIndex + 1, columnProvider);
        let style = convertLayoutPositionToFlexStyles(layout);

        return attachBehaviors(
            createDateColumnHeader(
                date,
                key,
                style,
                renderDateHeaderAddOn,
                onSurfaceClick,
                calendarFolderId
            ),
            [<ColumnPastDayHighlightBehavior key={'ColumnPastDayHighlightBehavior'} date={date} />]
        );
    });
}
